import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import moduleA from './modules/moduleA'
import moduleB from './modules/moduleB'

Vue.use(Vuex)

//数据仓库状态管理
const state = {
    count:'1',
    menuList:null,
    openKeys:"",
    selectedKeys:"",
    Cookies:null,
    userInfo:localStorage.getItem('userInfo')
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules:{
        moduleA,
        moduleB
    }
})
